export var ChatEventType;
(function (ChatEventType) {
    ChatEventType[ChatEventType["Create"] = 1] = "Create";
    ChatEventType[ChatEventType["SubmitForm"] = 2] = "SubmitForm";
    ChatEventType[ChatEventType["AgentConnect"] = 3] = "AgentConnect";
    ChatEventType[ChatEventType["CustomerConnect"] = 4] = "CustomerConnect";
    ChatEventType[ChatEventType["Message"] = 5] = "Message";
    ChatEventType[ChatEventType["CustomerDisconnect"] = 6] = "CustomerDisconnect";
    ChatEventType[ChatEventType["AgentDisconnect"] = 7] = "AgentDisconnect";
    ChatEventType[ChatEventType["TransferRequest"] = 8] = "TransferRequest";
    ChatEventType[ChatEventType["TransferSuccess"] = 9] = "TransferSuccess";
    ChatEventType[ChatEventType["TransferFailure"] = 10] = "TransferFailure";
    ChatEventType[ChatEventType["Finish"] = 11] = "Finish";
    ChatEventType[ChatEventType["LanguageChange"] = 12] = "LanguageChange";
    ChatEventType[ChatEventType["TransferCancel"] = 13] = "TransferCancel";
    ChatEventType[ChatEventType["ChangeBookingId"] = 14] = "ChangeBookingId";
    ChatEventType[ChatEventType["CustomerEndChat"] = 15] = "CustomerEndChat";
    ChatEventType[ChatEventType["CustomerRequestTranscript"] = 16] = "CustomerRequestTranscript";
    ChatEventType[ChatEventType["AgentRequestTranscript"] = 17] = "AgentRequestTranscript";
    ChatEventType[ChatEventType["AgentRejectInvite"] = 18] = "AgentRejectInvite";
    ChatEventType[ChatEventType["AgentInvite"] = 19] = "AgentInvite";
    ChatEventType[ChatEventType["AgentInviteTimeout"] = 20] = "AgentInviteTimeout";
    ChatEventType[ChatEventType["ResetInactivityTimer"] = 21] = "ResetInactivityTimer";
    ChatEventType[ChatEventType["IncreaseInactivityTimer"] = 22] = "IncreaseInactivityTimer";
    ChatEventType[ChatEventType["CustomerUrlChange"] = 23] = "CustomerUrlChange";
    ChatEventType[ChatEventType["EnterQueue"] = 24] = "EnterQueue";
    ChatEventType[ChatEventType["StopInactivityTimer"] = 25] = "StopInactivityTimer";
    ChatEventType[ChatEventType["StartInactivityTimer"] = 26] = "StartInactivityTimer";
    ChatEventType[ChatEventType["ProposedMessage"] = 27] = "ProposedMessage";
})(ChatEventType || (ChatEventType = {}));
//# sourceMappingURL=chat-event-type.js.map